import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useUpdateImage = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation((variables) => client.media.updateImage(variables), useMutationOptions);
};
//# sourceMappingURL=useUpdateImage.js.map